import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import './NoFoundPage.css'


const NoFoundPage = () => {
    const t = useTranslate()
    return (
        <>
            <div id="notfound">
                <div className="notfound">
                    <div className="notfound-404">
                        <h1>Oops!</h1>
                        <h2>404 - The Page can't be found</h2>
                    </div>
                    <a href="/start">go to homepage</a>
                </div>
            </div>
        </>

    )
}

export default NoFoundPage
